import React from 'react';
import * as ST from './styled';
import Link from 'next/link';

const LinksFooterComponent = (props) => {
    return <>
        {props.linksData.map((item, index) => {
            return (<ST.LinksBlock key={index}>
                <ST.LinksTitle>{item.title}</ST.LinksTitle>
                <ST.LinksList>
                    {item.linkList.map((item, index) => {
                        return (<Link key={index} href={item.link} prefetch={false}>
                            <ST.LinkFooter target='_blank' href={item.link}>{item.text}</ST.LinkFooter>
                        </Link>);
                    })}
                </ST.LinksList>
            </ST.LinksBlock>);
        })}
    </>;
};

export default LinksFooterComponent;
